<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">

        <div class="mt-4 mb-4 text-center">
            <h2 class="fw-bold mb-0" style="color:#1a202c;">My Attestation Campaigns</h2>
            <p class="text-muted mt-1 mb-0" style="font-size:.9rem;">These permissions carry extraordinary risk to Chevron. Review each campaign carefully — don't treat this as routine.</p>
        </div>

        @if (isLoading) {
        <div class="text-center py-5">
            <div class="mb-3" style="display:inline-block;"><mat-spinner [diameter]="40"></mat-spinner></div>
            <p class="text-muted">Loading your campaigns...</p>
        </div>
        }

        @if (!isLoading && loadError) {
        <div class="alert alert-danger">{{ loadError }}</div>
        }

        @if (!isLoading && !loadError) {

        @if (campaigns.length === 0) {
        <div class="text-center py-5 text-muted">
            <p class="mb-0">You have no attestation campaigns.</p>
        </div>
        }

        @if (campaigns.length > 0) {
        <div style="background:white;border:1px solid #e2e8f0;border-radius:6px;overflow:hidden;">
            <table class="table mb-0" style="font-size:.875rem;">
                <thead style="background:#f8f9fa;border-bottom:1px solid #e2e8f0;">
                    <tr>
                        <th class="px-3 py-2 fw-semibold text-muted" style="font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;border:none;">Application</th>
                        <th class="px-3 py-2 fw-semibold text-muted" style="font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;border:none;">Tier</th>
                        <th class="px-3 py-2 fw-semibold text-muted" style="font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;border:none;">Permissions</th>
                        <th class="px-3 py-2 fw-semibold text-muted" style="font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;border:none;">Initiated</th>
                        <th class="px-3 py-2" style="border:none;position:relative;">
                            <button (click)="toggleFilter($event)" style="background:none;border:none;padding:0;font-size:.75rem;font-weight:600;text-transform:uppercase;letter-spacing:.05em;color:#6b7280;cursor:pointer;">
                                Status
                                @if (statusFilter !== 'All') { <span style="font-size:.7rem;font-weight:400;text-transform:none;color:#374151;">· {{ statusFilter }}</span> }
                                <span style="font-size:.65rem;">▾</span>
                            </button>
                            @if (filterOpen) {
                            <div (click)="$event.stopPropagation()" style="position:absolute;top:100%;left:0;background:white;border:1px solid #e2e8f0;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,.1);z-index:100;min-width:130px;padding:4px 0;">
                                @for (f of filterOptions; track f) {
                                <button (click)="pickFilter(f)" style="display:block;width:100%;text-align:left;padding:6px 14px;background:none;border:none;font-size:.85rem;cursor:pointer;" [style.fontWeight]="statusFilter === f ? '600' : '400'" [style.color]="statusFilter === f ? '#1a202c' : '#4b5563'">{{ f }}</button>
                                }
                            </div>
                            }
                        </th>
                        <th class="px-3 py-2" style="border:none;"></th>
                    </tr>
                </thead>
                <tbody>
                    @if (pagedCampaigns.length === 0) {
                    <tr><td colspan="6" class="px-3 py-4 text-center text-muted" style="border:none;">No campaigns match this filter.</td></tr>
                    }
                    @for (campaign of pagedCampaigns; track campaign.campaignId + campaign.servicePrincipalObjectId) {
                    <tr style="border-top:1px solid #f0f2f5;">
                        <td class="px-3 py-3" style="border:none;">
                            <div class="fw-semibold">{{ campaign.servicePrincipalDisplayName }}</div>
                            <div class="text-muted" style="font-size:.78rem;">{{ campaign.campaignId }}</div>
                        </td>
                        <td class="px-3 py-3" style="border:none;vertical-align:middle;">
                            <span class="badge" style="background:#e8eaf6;color:#3949ab;font-weight:500;font-size:.8rem;padding:.2em .55em;margin-left:-.4em;">{{ campaign.permissionTier }}</span>
                        </td>
                        <td class="px-3 py-3" style="border:none;vertical-align:middle;color:#374151;">{{ campaign.permissionCount }}</td>
                        <td class="px-3 py-3" style="border:none;vertical-align:middle;color:#6b7280;">{{ campaign.initiatedDate | date:'mediumDate' }}</td>
                        <td class="px-3 py-3" style="border:none;vertical-align:middle;">
                            <span class="badge" [ngStyle]="statusStyle(campaign.status)" style="font-weight:500;font-size:.8rem;padding:.2em .55em;margin-left:-.4em;">{{ statusLabel(campaign.status) }}</span>
                        </td>
                        <td class="px-3 py-3 text-end" style="border:none;vertical-align:middle;">
                            <button class="btn btn-sm" [class.btn-primary]="campaign.status !== 'Complete'" [class.btn-outline-secondary]="campaign.status === 'Complete'" (click)="review(campaign)">{{ campaign.status === 'Complete' ? 'View' : 'Review' }}</button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        @if (filteredCampaigns.length > pageSize) {
        <div class="text-center mt-2">
            <button class="btn btn-link btn-sm text-muted" (click)="showMore()">Show more ({{ filteredCampaigns.length - pageSize }} remaining)</button>
        </div>
        }
        }

        }

    </section>
</main>
